import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import es from './es.json';
import en from './en.json';

export const LANGUAGES = ['es', 'en'] as const;
export type Language = (typeof LANGUAGES)[number];
export const DEFAULT_LANGUAGE: Language = 'es';
export const LANG_STORAGE_KEY = 'teo.lang';

export function isLanguage(value: unknown): value is Language {
  return typeof value === 'string' && (LANGUAGES as readonly string[]).includes(value);
}

/** Idioma guardado antes de iniciar sesión (tras el inicio de sesión se usa el del usuario). */
export function storedLanguage(): Language {
  try {
    const v = localStorage.getItem(LANG_STORAGE_KEY);
    return isLanguage(v) ? v : DEFAULT_LANGUAGE;
  } catch {
    return DEFAULT_LANGUAGE;
  }
}

export function persistLanguage(lang: Language) {
  try {
    localStorage.setItem(LANG_STORAGE_KEY, lang);
  } catch {
    /* almacenamiento no disponible: el idioma solo aplica a esta sesión */
  }
}

export async function changeLanguage(lang: Language) {
  persistLanguage(lang);
  document.documentElement.lang = lang;
  await i18n.changeLanguage(lang);
}

// El idioma declarado de la página debe coincidir con el mostrado desde la primera carga;
// si no, el navegador ofrece traducir una página que ya está en el idioma del usuario.
if (typeof document !== 'undefined') document.documentElement.lang = storedLanguage();

void i18n.use(initReactI18next).init({
  resources: { es: { translation: es }, en: { translation: en } },
  lng: storedLanguage(),
  fallbackLng: DEFAULT_LANGUAGE,
  interpolation: { escapeValue: false },
  returnNull: false,
  showSupportNotice: false,
});

export default i18n;
